import React from 'react';
import style from './style.module.css'
import { MantraImage, MissionImage, VisionImage } from '../../assets';
// import { TeamCard } from '../../components/cards';
// import { Button } from '../../components/buttons';

// const teamData = [
//   {
//     image: TeamImage,
//     title: 'Name Of Person',
//     position: 'Position'
//   },
//   {
//     image: TeamImage,
//     title: 'Name Of Person',
//     position: 'Position'
//   },
//   {
//     image: TeamImage,
//     title: 'Name Of Person',
//     position: 'Position'
//   },
//   {
//     image: TeamImage,
//     title: 'Name Of Person',
//     position: 'Position'
//   },
//   {
//     image: TeamImage,
//     title: 'Name Of Person',
//     position: 'Position'
//   },
//   {
//     image: TeamImage,
//     title: 'Name Of Person',
//     position: 'Position'
//   },
//   {
//     image: TeamImage,
//     title: 'Name Of Person',
//     position: 'Position'
//   },
//   {
//     image: TeamImage,
//     title: 'Name Of Person',
//     position: 'Position'
//   },
// ]

const AboutUs = () => {
  return (
    <main>
      <header className={style.header}>
        {/* <h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore</h2> */}
        {/* <br/> */}
        <p>
          Norlics Digital Services came as a subsidiary of Norlics Limited following the need to have a local presence in Enugu state.  Globally, Norlics is  an ICT services company with focus on IT Consulting and Advisory, Payment Solutions, Cloud Computing, IT Governance, Infrastructure Services, Application development and Information Security. In addition, we also offer website development and Digital Marketing services.

        </p>
        <p>
          We have been in existence since September, 2018 but boasts of an accumulated staff experience of over 20 years in providing IT services to customers in various business categories in Nigeria. We are inspired by the simple belief that there are no issues that do not have solutions.
        </p>
      </header>
      <section className={style.vision__deets}>
        <div className={style.vision__deets_strip_ltr}>
          <div className={style.vision__deets_text}>
            <h4>Our Vision</h4>
            <p>
              Our vision is to be a preeminent global firm, recognized for our unwavering commitment to excellence and innovation. We aim to continuously offer best-in-class products and services that not only meet but consistently exceed the evolving expectations and needs of our diverse and growing clientele. Through our dedication to quality, customer satisfaction, and sustainable growth, we strive to create lasting value and become the preferred partner in every market we serve, setting the standard for industry leadership worldwide.
            </p>
          </div>
          <div className={style.vision__deets_image}>
            <img src={VisionImage} alt='A pictorial depiction of Vision' />
          </div>
        </div>
        <div className={style.vision__deets_strip_rtl}>
          <div className={style.vision__deets_image}>
            <img src={MissionImage} alt='A pictorial depiction of Mision' />
          </div>
          <div className={style.vision__deets_text}>
            <h4>Our Mission</h4>
            <p>
              Our mission is to exemplify the highest standards of professionalism by consistently and efficiently delivering specialized products and services that are tailored to meet the unique needs of our customers. We are committed to fostering innovation, precision, and excellence in every aspect of our operations, ensuring that we not only meet but surpass the expectations of our clients. By leveraging our expertise and industry insights, we strive to create a distinct competitive edge for our customers, empowering them to achieve their goals and thrive in an ever-changing global marketplace.
            </p>
          </div>
        </div>
        <div className={style.vision__deets_strip_ltr}>
          <div className={style.vision__deets_text}>
            <h4>Our Mantra</h4>
            <p>
              Greatness in service is our guiding principle, rooted in our deep passion and unwavering desire to make a meaningful difference in every aspect of our undertakings. We believe that true excellence is achieved through dedication to serving others with integrity, care, and a relentless pursuit of quality. This commitment drives us to go above and beyond in all that we do, ensuring that every interaction, product, and service reflects our wholehearted commitment to making a positive impact and leaving a lasting legacy of excellence.
            </p>
          </div>
          <div className={style.vision__deets_image}>
            <img src={MantraImage} alt='A pictorial depiction of Mantra' />
          </div>
        </div>
      </section>
      {/* <section className={style.our__team}>
        <div className={style.our__team_wrapper}>
          <h4>Meet Our Team</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
          </p>
          <div className={style.our__team_slider_container}>
            <div className={style.our__team_slider}>
              {teamData.map(({ image, title, position }, index) => (
                <React.Fragment key={index}>
                  <TeamCard
                    image={image}
                    header={title}
                    description={position}
                    alt='Team'
                  />
                </React.Fragment>
              )
              )}
            </div>
          </div>
        </div>
      </section> */}
      {/* <section className={style.book_consult}>
        <h3>Lorem ipsum dolor sit amet, consectetur</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.</p>
        <Button
          children={'Book Consultation'}
        />
      </section> */}
    </main>
  )
}

export default AboutUs